<template>
  <div class="main" :class="{backColorB: bCb}" @click="clearRightMenu"
       @click.right="clearRightMenu">
    <div class="editor-header-top">
      <editor-header></editor-header>
    </div>
    <editorTop :taskTypeNames='taskTypeName' :queryDatas="queryData" :bCbs="bCb"
               :isSeekBoxs="isSeekBox" :isSplits="isSplit" :ifSubmits="ifSubmit"
               :termSubmits="termSubmit" :isSourceEds="isSourceEd" :roleLevels="roleLevel"
               :interpreteruids="interpreteruid" @visionPattern="visionPattern"
               :sentenceShows="sentenceShow" @seekShow="seekShow" @rigBoxShow="rigBoxShow"
               @sizeEnlarge="sizeEnlarge" @sizeNarrow="sizeNarrow" @submit="submit"
               @copySource="copySource" @anewTranslate="anewTranslate" @sourceEditor="sourceEditor"
               @reTranslate="reTranslation" @interpreterTask="interpreterTask"
               @interpreterTaskOut="interpreterTaskOut" @toTaskIndex="toTaskIndex" :states="state">

    </editorTop>
    <div id="bagBox" :class="{backColorB: bCb}">
      <div class="box cat-trans" id="redactBox" ref="redactBox">
        <div class="cen" id="translation" ref="viewBox2" @mouseup="pitchOn" @click="getHint($event)"
             @contextmenu="oncontextmenu" @input="AutoComple($event)">
          <!---->
          <!-- @keyup.shift.32="lkl" -->
          <!-- @input="changeText($event)" -->
          <div v-for="(item, index) in targetList" :key="index" v-html="item.data"></div>
          <postil style="top:5px" :isAddPostil="isAddPostil" :isUpdatePostil="isUpdatePostil"
                  @setIsSeekBox="setIsSeekBox"></postil>
        </div>
      </div>
      <div class="rigContantBox" ref="rigContantBox">
        <!-- <i class="icon-left riBoxSw" v-show="RigBoxIf" @click="startRigBox"></i>
                <i class="icon-right riBoxSw" v-show="!RigBoxIf" @click="startRigBox"></i> -->
        <editorOperation ref="editorOperation" :termHintList="termHintList"
                         :memoryHintList="memoryHintList" :isSeekBox="isSeekBox" :seekTxt="seekTxt"
                         :seekTxt2="seekTxt2" :seekNum="seekNum" :seekNum2="seekNum2"
                         :inputTxt="inputTxt" :queryData="queryData" :bCb="bCb"
                         :targetInput="targetInput" :postilTarget="postilTarget"
                         :ifSubmit="isUpdatePostilBut" :updatePostilTxt="updatePostilTxt"
                         :postilId="postilId" @addTerm="addTerm" @onInputTxt="onInputTxt"
                         @onTargetInput="onTargetInput" @onSeekTxt="onSeekTxt"
                         @onSeekTxt2="onSeekTxt2" @setPostilId="setPostilId"
                         @onUpdatePostilTxt="onUpdatePostilTxt" @setIsSeekBox="setIsSeekBox"
                         @goQA="goQA" @seekChange="seekChange" @onReplace="onReplace"
                         @replaceChange="replaceChange" @previous="previous" @seekNext="seekNext">
        </editorOperation>
      </div>
    </div>
    <rightMenu ref="rightMenu" v-show="rightMenuShow" @rigBoxShow="rigBoxShow"
               @rigAddTerm="rigAddTerm" :format="(queryData.fileSuffix)"
               @anewTranslate="anewTranslate" @copySource="copySource" :sentenceShow="sentenceShow"
               :ifSubmit="ifSubmit" :typeShow="typeShow" :isXlsx="isXlsx" :isEditR="isEditR" />
    <messageBox v-if="mesBox" :isShow="mesBox" :tit="tit" :txt="txt" :imgSrc="imgSrc" :cancel="true"
                confirmBut="保存并替换" callBut="保存" @message="empty" @messageIf="messageIf"
                @onCancel="onCancel"></messageBox>
    <!-- 单词补全开始 -->
    <div id="WordBox" ref="WordBox" v-show="isWordBox">
      <ul>
        <li v-for="(item, index) in words" :key="index">
          {{ item }}
        </li>
      </ul>
    </div>
    <!-- 单词补全结束 -->
    <!-- <div  v-if="isSeekBox">
          <input type="text" v-model="seekTxt" />
          <input type="text" v-model="seekTxt2" />
          <button @click="seekChange">查找</button>
          <button class="replace" @click="seek">替换</button>
        </div>-->
    <!-- 术语添加弹窗 -->
    <termDialog :dialogVisible="dialogVisible"></termDialog>
    <!-- 术语添加弹窗 -->
  </div>
</template>

<script>
// import Vue from "vue";

import { setTimeout } from "timers";
import { seekShow } from "./common";
import messageBox from "@/common/messageBox.vue";
import editorHeader from "../../../editorTop/index.vue";
// import editorHeader from "./common/editorHeader.vue";
import editorTop from "./common/editorTop.vue";
import rightMenu from "./common/rightMenu.vue";
import editorMixin from './common/mixin';
import seek from './common/seek.vue';
import editorOperation from './common/editorOperation.vue';
import postil from './common/postil.vue';
import termDialog from './common/termDialog.vue';
import { mapActions } from 'vuex';
// var myAppendTo = Vue.extend({
//   template: "<p>appendTo</p>"
// });
let rightClickElement;
export default {
  mixins: [editorMixin],
  data () {
    return {
      targetList: [],
      sourceList: [],
      scroll: "",
      rightMenuShow: false,
      txtList: [], // 复制用的
      isTerm: false,
      isSearch: false,
      inputTxt: "",
      inputTxt2: "",
      timer: null,
      timer2: null,
      timeOut: null,
      scale_x: "1",
      scale_y: "1",
      targetInput: "",
      dictItemList: "", // 存储查词数据
      loading: "",
      userId: "",
      termHintList: [],
      memoryHintList: [],
      num: "1",
      imgSrc: require("@/assets/imgs/editor/qr_code_bg.png"), // 弹窗title背景图
      mesBox: false,
      tit: "添加术语",
      txt: "是否保存到项目术语库并替换所有未确认句段？",
      queryData: "",
      saveHint: "",
      placeholder: true,
      isWordBox: false,
      words: [],
      seekTxt: "",
      seekTxt2: "",
      project: false,
      cutOff: false,
      isSeekBox: false, // 1 = 查找/替换 2 = 查词 3 = 添加术语
      completion: "",
      contextRight: "",
      seekIndex: 0,
      seekNum: 0,
      seekNum2: 0,
      loadinginstace: "",
      mendSentId: "",
      cursor: "", // 光标
      RigBoxIf: true,
      isSplit: 1,
      backgroundImg: require("@/assets/imgs/editor/normal_lock.png"),
      ev: "",
      updateTime: null,
      isBack: true, // 用户回退到那个界面
      progress: 0,
      taskTypeName: "",
      bCb: false,
      vision: '',
      myZoom: 1,
      editorDe: "#cfe8cc", // 编辑器完成的样式
      seekOut: "",
      progressTime: null,
      ifOnlyPreview: false, // 全文不可编辑为1
      isXlsx: false,
      state: true,
    };
  },
  async created () {
    var that = this;
    await this.queryBySentId();
    that.getWord("1", 1, true);
    that.str = "111";
  },
  updated () {
  },
  components: {
    editorHeader,
    editorTop,
    messageBox,
    rightMenu,
    editorOperation,
    postil,
    termDialog
  },
  mounted () {
    var that = this;
    // 通过$refs获取dom元素
    let dom = that.$refs.redactBox;
    // dom.addEventListener("drop", function (event) {
    //   // 获取拖拽文本内容
    //   var text = event.dataTransfer.getData("text");
    //   if (
    //     this.value == "" &&
    //     text.match(/\d/g) &&
    //     text.match(/\d/g).length == 11
    //   ) {
    //     event.preventDefault();
    //     dom.value = text.replace(/\D/g, "");
    //     dom.select();
    //   }
    // });
    // 监听这个dom的scroll事件
    // var sourceText = document.getElementById("sourceText").clientHeight;
    // dom.addEventListener('mousedown', function (e) {
    //   console.log('-----------');
    // })
    // window.addEventListener('mouseover mouseleave', function (event) {
    //   console.log('---------------------------------111111111111111111');
    //   is_confirm = event.type == 'mouseleave';
    // });

    // that.$refs.viewBox2.addEventListener("scroll", this.handleScroll(), false);
    that.$refs.viewBox2.addEventListener(
      "scroll", this.viewBoxScroll, false
    );
    this.getprogress();
  },
  beforeDestroy () {
    this.$message.closeAll();
    this.$refs.viewBox2.removeEventListener("scroll", this.viewBoxScroll);
    this.loadinginstace.close(); // loading清除
    clearTimeout(this.progressTime)
  },
  methods: {
    ...mapActions('editor', [
      'updateAddTemporaryTermList',
    ]),
    // 跳到任务页码
    toTaskIndex (data) {
      console.log(this.endIndex, ">>>>>");
      if (this.endIndex <= 20) {
        if (this.endIndex >= data.startPartIndex) {
          let dom = this.$refs.redactBox.querySelector(`div[uid='${data.uid}']`);
          dom.scrollIntoView()
        } else {
          for (let index = this.endIndex; index < data.startPartIndex; index++) {
            this.getWord(index, 1);
            this.num = index;
          }
          let dom = this.$refs.redactBox.querySelector(`div[uid='${data.uid}']`);
          dom.scrollIntoView()
        }
      } else {
        if (this.endIndex - 20 < data.startPartIndex && this.endIndex >= data.startPartIndex) {
          let dom = this.$refs.redactBox.querySelector(`div[uid='${data.uid}']`);
          dom.scrollIntoView()
        } else {
          this.sourceList = [];
          this.targetList = [];
          if (data.startPartIndex > 2) {
            this.getWord(data.startPartIndex - 2, 1)
            this.num = data.startPartIndex - 2;
          } else {
            this.getWord(data.startPartIndex, 1)
            this.num = data.startPartIndex;
          }

          let dom = this.$refs.redactBox.querySelector(`div[uid='${data.uid}']`);
          dom.scrollIntoView()
          if (!this.hasScrollbar(this.$refs.redactBox)) {

          }
        }
      }
    },
    // 取消译员任务段落高亮
    interpreterTaskOut () {
      let taskType = this.queryData.taskType;
      this.interpreterTaskDomList.forEach(item => {
        let status = item.getAttribute("status");
        let title = item.getAttribute("title");
        if (
          ((status == 2 && taskType === 1) ||
            (status == 4 && taskType === 2) ||
            (status == 5 && taskType === 3)) &&
          title !== "其他译员任务" &&
          item.isContentEditable
        ) {
          item.style.background = this.editorDe;
        } else {
          item.style.background = "";
        }
      })
    },
    // 译员任务段落高亮
    interpreterTask (uid) {
      let doms = this.$refs.viewBox2.querySelectorAll(`div[uid='${uid}']`);
      this.interpreterTaskDomList = []
      doms.forEach(item => {
        if (item.getAttribute("type") === "target") {
          this.interpreterTaskDomList.push(item)
          item.style.background = "#DBEEFF"
        }
      })
    },
    // qa用来定位dom
    domFun (row) {
      return this.$refs.viewBox2.querySelectorAll(
        `div[sid='${row.id}']`
      )[1];
    },
    // 用来编辑原文
    sourceDomFun (id) {
      return this.$refs.viewBox2.querySelectorAll(
        `div[sid='${id}']`
      )[0];
    },

    // // 设置批注
    setPostilId (item, res) {
      let that = this;
      this.isAddPostil = false;
      function set (item, i) {
        let parentDom = item.parentNode;
        if (item.getAttribute("pid")) {
          let pDom = that.$refs.redactBox.querySelector(
            `span[pid='${item.getAttribute("pid")}']`
          );
          pDom.setAttribute("txt", i.comment);
          return;
        }
        item.setAttribute("pid", i.sentId);
        parentDom.style.position = "relative";
        let strNode = document.createElement("span"); // 创建一个节点用来放拆分的上一部分
        strNode.className = "XlsxpostilBut";
        strNode.setAttribute("pid", i.sentId);
        strNode.setAttribute("txt", i.comment);
        strNode.setAttribute("postilId", i.id);
        strNode.onclick = async function ($event, item) {
          //  console.log("点击展开批注")                                                                                   
          let target = $event.target;
          that.updatePostilTxt = target.getAttribute("txt");
          that.postilId = target.getAttribute("pid");
          let dom = that.$refs.redactBox.querySelector(
            `div[pid='${that.postilId}']`
          );
          that.isSeekBox = 5;
          that.isAddPostil = false
          // console.log(  that.isSeekBox)
          if (!that.RigBoxIf) {
            that.startRigBox();
          }
          const { fileId } = that.queryData
          const params = {
            transFileId: fileId,
            sentIdList: [that.postilId]
          }
          await that.getCurrentRemarksInfo(params)
          that.postilTarget = {
            txt: dom.innerText,
            sid: that.postilId,
            butTag: target,
            tag: dom,
            id: target.getAttribute("postilId"),
          };
        };
        parentDom.appendChild(strNode);
      }

      if (res) {
        // 新增批注 修改
        set(item, res);
        return;
      }
      this.postilList.forEach((i) => {
        if (item.getAttribute("sid") == i.sentId) {
          set(item, i);
        }
      });
    },
    // 复制原文到译文
    copySource () {
      let domList = this.$refs.redactBox.querySelectorAll(
        `div[sid='${this.sid}']`
      );
      domList[1].innerText = domList[0].innerText;
      this.sentenceShow = false;
      this.changeText(domList[1])
    },
    // 滑动
    viewBoxScroll () {
      let that = this;
      this.rightMenuShow = false;
      let viewBox2 = that.$refs.viewBox2;
      let htmlHeight = viewBox2.clientHeight;
      if (viewBox2.scrollTop + htmlHeight + 50 > viewBox2.scrollHeight) {
        if (!that.timer2) {
          if (that.cutOff) {
            return;
          }
          that.num++;
          that.timer2 = setTimeout(function () {
            that.getWord(that.num, 1);
            that.timer2 = null;
          }, 500);
        }
      }
      if (viewBox2.scrollTop < 50 && that.num > 20) {
        that.cutOff = false;
        let page = "";
        if (!that.timeOut) {
          that.timeOut = setTimeout(function () {
            page = that.num - 20;
            that.num--;
            that.getWord(page, 2);
            that.timeOut = null;
          }, 500);
        }
      }
    },
    visionPattern (e) {
      let taskType = this.queryData.taskType;
      if (e == "1") {
        this.bCb = false;
        sessionStorage.setItem("sessionBCb", this.bCb)
        this.editorDe = "#cfe8cc"; //确定块的
        this.editorOff = "rgb(170,170,170)";
        this.editorNo = "#454545";
        // 编辑器字体颜色  译文
        let translation = document.getElementById("translation");
        let ary = translation.getElementsByTagName("div");
        let arr = Array.from(ary);
        arr.forEach(item => {
          let status = item.getAttribute("status");
          if (item.getAttribute("contenteditable") === this.contentEditableValue && item.getAttribute("type") === "target") {
            item.style.color = this.editorNo
          } else {
            item.style.color = this.editorOff
          }
          if (
            (
              (status == 2 && taskType === 1) ||
              (status == 4 && taskType === 2) ||
              (status == 5 && taskType === 3)
            ) &&
            (item.getAttribute("contenteditable") === this.contentEditableValue && item.getAttribute("type") === "target")) {
            // status值为 -1删除 0未翻译 1机器翻译 2已编辑 3已完成 4审校
            item.style.background = this.editorDe;
          }

        });
        // 原文
        // let sourceText = document.getElementById("sourceText");
        // let ary1 = sourceText.getElementsByTagName("div");
        // let arr1 = Array.from(ary1);
        // arr1.forEach(item => {
        //   item.style.color = "#454545"
        //   if (item.getAttribute("status") === "2") {
        //     // status值为 -1删除 0未翻译 1机器翻译 2已编辑 3已完成 4审校
        //     item.style.background = "#cfe8cc";
        //   }
        // });

      } else if (e == "2") {
        this.bCb = true;
        sessionStorage.setItem("sessionBCb", this.bCb)
        this.editorDe = "#50606e" //确定块的颜色
        this.editorOff = "#696A6D";
        this.editorNo = "#AAABAD";
        // 编辑器字体颜色  译文
        let translation = document.getElementById("translation");
        let ary = translation.getElementsByTagName("div");
        let arr = Array.from(ary);
        arr.forEach(item => {
          let status = item.getAttribute("status");
          if (item.getAttribute("contenteditable") === this.contentEditableValue && item.getAttribute("type") === "target") {
            item.style.color = this.editorNo
          } else {
            item.style.color = this.editorOff
          }
          if (
            (
              (status == 2 && taskType === 1) ||
              (status == 4 && taskType === 2) ||
              (status == 5 && taskType === 3)
            ) &&
            (item.getAttribute("contenteditable") === this.contentEditableValue && item.getAttribute("type") === "target")) {
            // status值为 -1删除 0未翻译 1机器翻译 2已编辑 3已完成 4审校
            item.style.background = this.editorDe;
          }

        });
        // 原文
        // let sourceText = document.getElementById("sourceText");
        // let ary1 = sourceText.getElementsByTagName("div");
        // let arr1 = Array.from(ary1);
        // arr1.forEach(item => {
        //   item.style.color = "#696A6D"
        // });

      }
    },
    // 重新机翻句段
    anewTranslate () {
      let that = this;
      let sid = rightClickElement.target.getAttribute("sid");
      let sourceTag = this.$refs.viewBox2.querySelectorAll(`div[sid='${sid}']`)[1];
      if (!sourceTag.isContentEditable) {
        this.$message.closeAll();
        this.$message({
          message: "不可编辑句段不支持重新机翻",
          type: "warning"
        });
        return
      }
      if (!sid) {
        return
      }
      this.catReq1Service(
        "/api/v1/file/get_sent_machine_translation",
        {
          sid,
          companyCode: localStorage.myCompanyCode,
          taskType: this.queryData.taskType,
          fileId: that.queryData.fileId,
          taskId: this.queryData.taskId
        },
        "get"
      ).then(function (response) {
        if (!response.success) {
          return;
        }
        that.sentenceShow = false;
        sourceTag.innerText = response.result.convertStr;
        that.changeText(sourceTag)
      });
    },
    // 缩小
    sizeNarrow () {
      if (this.myZoom < 0.9) {
        return
      }
      this.myZoom = this.myZoom - 0.2
      this.$nextTick(() => {
        this.$refs.viewBox2.style.zoom = this.myZoom;
      })
    },
    // 放大
    sizeEnlarge () {
      if (this.myZoom > 1.1) {
        return
      }
      this.myZoom = this.myZoom + 0.2;
      this.$nextTick(() => {
        this.$refs.viewBox2.style.zoom = this.myZoom;
      });

    },
    //  右侧菜单开关
    startRigBox () {
      if (!this.RigBoxIf) {
        this.RigBoxIf = true;
        this.RigSwitchVal = "true";
        this.$nextTick(() => {
          this.$refs.redactBox.style.width = "calc(100% - 360px)";
          this.$refs.rigContantBox.style.width = "300px";
          this.$refs.rigContantBox.style.marginRight = "20px";
        });
      } else {
        this.RigBoxIf = false;
        this.RigSwitchVal = "false";
        this.$nextTick(() => {
          this.$refs.redactBox.style.width = "calc(100% - 40px)";
          this.$refs.rigContantBox.style.width = "0px";
          this.$refs.rigContantBox.style.marginRight = "0";
        });
      }
    },
    // 开启编辑器
    codeRigBox () {
      this.RigBoxIf = true;
      this.RigSwitchVal = "true";
      this.$nextTick(() => {
        this.$refs.redactBox.style.width = "calc(100% - 360px)";
        this.$refs.rigContantBox.style.width = "300px";
        this.$refs.rigContantBox.style.marginRight = "20px";
      });
    },
    seekShow () {
      //  this.seekChange()
      var that = this;
      that.codeRigBox();
      if (that.isSeekBox === 1) {
        that.isSeekBox = false;
        let dom = document.getElementById("translation");
        let seekActive = dom.getElementsByClassName("seekActive");
        let len = seekActive.length;
        if (len > 0) {
          for (let i = len - 1; i > -1; i--) {
            if (i >= 0) {
              seekActive[i].style.background = "";
              seekActive[i].classList.remove("seekActive");
            }
          }
        }
        that.seekTxt = "";
      } else {
        that.isSeekBox = 1;
        // that.seekChange();
      }
    },
    // 查找 下一个
    seekNext () {
      let domList = document.getElementsByClassName("seekActive");
      if (domList.length === 0 || domList.length === 1) {
        return;
      }
      if (this.seekIndex >= domList.length - 1) {
        domList[0].style.background = "rgb(163, 217, 241)";
        domList[this.seekIndex].style.background = "yellow";
        this.seekIndex = 0;
        domList[this.seekIndex].scrollIntoView();
        this.seekNum = 1;
        return;
      }

      this.seekIndex++;
      this.seekNum++;
      // console.log(this.seekIndex);
      domList[this.seekIndex].scrollIntoView();
      // let top = this.$refs.viewBox2.scrollTop;
      // this.$refs.viewBox2.scrollTo(0, num);
      if (this.seekIndex > 0) {
        domList[this.seekIndex].style.background = "rgb(163, 217, 241)";
        domList[this.seekIndex - 1].style.background = "yellow";
      } else {
        domList[this.seekIndex].style.background = "rgb(163, 217, 241)";
      }
    },
    // 查找 上一个
    previous () {
      let domList = document.getElementsByClassName("seekActive");
      let len = domList.length;
      if (len === 0 || len === 1) {
        return;
      }

      if (this.seekIndex === 0) {
        domList[len - 1].style.background = "rgb(163, 217, 241)";
        domList[0].style.background = "yellow";
        this.seekIndex = len - 1;
        domList[this.seekIndex].scrollIntoView();
        this.seekNum = len;
        return;
      }
      this.seekIndex--;
      this.seekNum--;
      domList[this.seekIndex].scrollIntoView();
      domList[this.seekIndex].style.background = "rgb(163, 217, 241)";
      domList[this.seekIndex + 1].style.background = "yellow";
    },
    // 查找
    seekChange () {
      let domList = document.getElementsByClassName("seekActive");
      let len = domList.length;
      if (len > 0) {
        for (let i = len - 1; i > -1; i--) {
          if (i >= 0) {
            domList[i].style.background = "";
            domList[i].classList.remove("seekActive");
          }
        }
      }
      this.seekNum2 = 0;
      this.seekNum = 0;
      this.seekIndex = 0;
      if (this.seekTxt === "") {
        return;
      }
      let oAt = this.$refs.viewBox2;
      let dom = oAt.querySelectorAll(`div[sid]`);
      let seekTxt = this.seekTxt;
      if (seekTxt.indexOf(".") != -1 || seekTxt.indexOf("?") != -1) {
        let ary = seekTxt.split("")
        for (let i = 0; i < ary.length; i++) {
          if (ary[i] === "." || ary[i] === "?") {
            ary[i] = "\\" + ary[i]
          }
        }
        seekTxt = ary.join("")
      }
      let reg = new RegExp(seekTxt, "ig");
      dom.forEach((item, index) => {
        // if (item.getAttribute("type") === "target" || item.getAttribute("contenteditable") === this.contentEditableValue) {
        let result = reg.exec(item.innerText);
        if (result) {
          let activeStr = item.innerText.replace(reg, function (params) {
            console.log(params);
            return (
              '<span class="seekActive" style="background:yellow;">' +
              params +
              "</span>"
            );
          });
          item.innerHTML = activeStr;
          this.$nextTick(() => {
            let domActList = document.getElementsByClassName("seekActive");
            this.seekNum2 = domActList.length;
            this.seekNum = 1;
            domActList[0].style.background = "rgb(163, 217, 241)";
          });
        }
        // }
      });
      if (!seekTxt) {
        // this.$message.closeAll();
        // this.$message({
        //   message: "请输入要查找的内容",
        //   type: "warning"
        // });
        return;
      }
    },
    // 替换
    onReplace () {
      if (!this.ifSubmit) {
        // 提交任务不可以替换
        this.$message.closeAll();
        this.$message({
          message: "不可修改",
          type: "warning"
        });
        return;
      }
      let domList = document.getElementsByClassName("seekActive");
      if (domList.length < 1) {
        // 为空时不执行
        return;
      }
      let dom = domList[this.seekIndex].parentNode;
      if (dom.getAttribute("type") === "source" || !dom.isContentEditable) {
        // 只可编辑替换
        return;
      }
      let sonDom = domList[this.seekIndex];
      sonDom.style.background = "";
      sonDom.innerText = this.seekTxt2;
      sonDom.classList.remove("seekActive");
      this.changeText(dom);
      this.$nextTick(() => {
        this.seekNum2 = domList.length;
        if (this.seekNum > this.seekNum2) {
          this.seekNum = this.seekNum2;
          this.seekIndex--;
          domList[this.seekIndex].style.background = "rgb(163, 217, 241)";
        } else {
          this.seekIndex ? domList[this.seekIndex].style.background = "rgb(163, 217, 241)" : '';
        }
      });
      if (this.seekNum2 === 1) {
        this.seekNum = 0;
      }
    },
    // 全部替换
    replaceChange () {
      // this.$nextTick(()=>{
      //   var viewBox = this.$refs.redactBox.innerHTML
      //  var p = viewBox.split(this.seekTxt).join("<span>"+this.seekTxt2+"</span>")
      //  viewBox = p;
      // })
      let that = this;
      if (!this.ifSubmit) {
        // 提交任务不可以替换
        this.$message.closeAll();
        this.$message({
          message: "不可修改",
          type: "warning"
        });
        return;
      }
      var str2 = this.seekTxt;
      var str3 = this.seekTxt2;
      var oAt = this.$refs.viewBox2;
      let str1 = this.$refs.viewBox2.innerHTML;
      if (!str2) {
        // this.$message.closeAll();
        // this.$message({
        //   message: "请输入要替换的内容",
        //   type: "warning"
        // });
        return;
      }
      let dom = oAt.querySelectorAll(`div[sid]`);
      let seekTxt = this.seekTxt;
      if (seekTxt.indexOf(".") != -1 || seekTxt.indexOf("?") != -1) {
        let ary = seekTxt.split("")
        for (let i = 0; i < ary.length; i++) {
          if (ary[i] === "." || ary[i] === "?") {
            ary[i] = "\\" + ary[i]
          }
        }
        seekTxt = ary.join("")
      }
      let reg = new RegExp(this.seekTxt, "ig");
      dom.forEach(item => {
        if (
          item.getAttribute("type") === "target" &&
          item.getAttribute("contenteditable") === that.contentEditableValue
        ) {
          let text = item.innerHTML;
          let result = reg.exec(item.innerText);
          if (result) {
            if (str3 === "" && item.innerText === "") {
              // 阻止修改为空
              return;
            }
            let activeStr = item.innerText.replace(reg, function (params) {
              return (
                '<span class="seekActive" style="background:yellow;">' +
                str3 +
                "</span>"
              );
            });
            that.seekIndex = 0;
            item.innerHTML = activeStr;
            if (item.innerText === "") {
              item.innerHTML = text;
              this.$message.closeAll();
              this.$message({
                message: "对应的译文不能为空",
                type: "warning"
              });
            }
          }
        }
      });
      var seekDom = document.getElementsByClassName("seekActive");
      seekDom = Array.from(seekDom);
      this.$nextTick(() => {

        for (let i = 0; i < seekDom.length; i++) {
          if (seekDom[i].parentNode) {
            if (seekDom[i].parentNode.isContentEditable && seekDom[i].parentNode.getAttribute("type") === "target") {
              this.changeText(seekDom[i].parentNode);
            }
          }
        }
        // this.seekNum2 = 0;
        // this.seekNum = 0;
        this.seekChange();
      });
    },
    // 提交任务
    submit () {
      var that = this;
      this.loadinginstace = this.$loading({ fullscreen: true });
      this.catReq1Service("/api/v1/fileTask/finishTask", {
        id: that.queryData.fileId,
        taskType: that.queryData.taskType,
        taskId: this.queryData.taskId
      }).then(function (response) {
        if (!response.success) {
          that.loadinginstace.close(); // loading清除
          return;
        }
        if (response.resultCode === "1") {
          that.ifOnlyPreview = false;
          that.$message.closeAll();
          that.$message({
            message: "提交任务成功",
            type: "success"
          });
          that.isSeekBox == 5 || that.isSeekBox == 4 ? that.isSeekBox = '' : '';
          that.isAddPostil = false;
          that.isUpdatePostil = false;
          that.getprogress();
          var translation = document.getElementById("translation");
          var ary = translation.getElementsByTagName("div");
          setTimeout(() => {
            var arr = Array.from(ary);
            //  console.log( document.getElementsByClassName("lef").firstElementChild,"redactBox.firstElementChild")
            arr.forEach(item => {
              // if (item.getAttribute("editCode")) {
              if (item.getAttribute("contenteditable")) {
                item.setAttribute("contenteditable", "false");
                item.style.color = that.editorOff;
                item.style.background = "";
              }
            });
            that.loadinginstace.close(); // loading清除
          }, 10);
          that.checkTaskStatus();
        }
      });
    },
    reTranslation () {
      let that = this;
      that.ifOnlyPreview = false;
      that.isAddPostil = false;
      that.isUpdatePostil = false;
      // that.getTaskProgress();
      this.getprogress();
      let translation = document.getElementById("translation");
      let ary = translation.getElementsByTagName("div");
      setTimeout(() => {
        let arr = Array.from(ary);
        arr.forEach(item => {
          if (item.getAttribute("contenteditable")) {
            item.setAttribute("contenteditable", "false");
            item.style.color = that.editorOff;
            item.style.background = "";
          }
        });
        that.loadinginstace.close(); // loading清除
      }, 10);
    },
    getprogress () {
      let urlInfo = this.$store.getters['editor/getUrlInfo'];
      if (urlInfo.type === "task" || urlInfo.type === "school") {
        let data = Object();
        Reflect.set(data, 'id', (urlInfo.fileId));
        Reflect.set(data, 'fileId', (urlInfo.fileId));
        Reflect.set(data, 'taskId', (urlInfo.taskId));
        Reflect.set(data, 'taskType', (urlInfo.taskType));
        this.$store.dispatch('editor/getTaskProgress', data);
      } else {
        this.$store.dispatch("editor/getFileInfo", { id: urlInfo.fileId })
      }
    },
    getHint (e) {
      rightClickElement = e;
      this.isFunBut(e);
      this.isXlsx = true;
      const node = this.getNode(e.target);
      if (node.getAttribute("type") === "target") {
        this.isSeekBox = false;
      }
      let acticeClass = e.target.getAttribute("sid");
      if (!acticeClass) {
        return;
      }
      let lefTag = this.$refs.viewBox2.querySelector(
        `div[sid='${acticeClass}']`
      );
      this.getmemory(lefTag.innerText)
      this.getTerm(lefTag.innerText)
      if (e.target.getAttribute('type') === "target") {
        // if (this.contrastStatus) {
        //   this.contrastTag.innerHTML = this.contrastTag.innerText
        // }
        // if (e.target.isContentEditable) {
        //   let range = window.getSelection().getRangeAt(0);
        //   if (this.startOffset != range.startOffset) {
        //     this.contrastDebounce(lefTag, e.target)
        //   }
        // }
      }
    },
    // 自定义右键菜单
    oncontextmenu (e) {
      rightClickElement = e;
      this.isFunBut(e);
      e = e || window.event;
      window.event.returnValue = false;
      this.rightMenuShow = true;
      let rm = this.$refs.rightMenu.$el;
      this.sid = e.target.getAttribute("sid")
      //2.设置菜单的位置等于鼠标的坐标
      //判断：如果鼠标的位置+菜单的宽度>网页的宽度，那么就改为右边定位
      //鼠标坐标
      let mx = e.clientX;
      let my = e.clientY;
      //菜单宽度
      this.$nextTick(() => {
        let rmWidth = parseInt(rm.clientWidth);
        let rmHeight = parseInt(rm.clientHeight);
        //网页的宽度(高度用同样的方法解决)
        let pageWidth = document.documentElement.clientWidth;
        let pageHeight = document.documentElement.clientHeight;
        if (mx + rmWidth < pageWidth) {
          rm.style.left = mx + 10 + "px";
        } else {
          rm.style.left = mx - rmWidth - 10 + "px";
        }
        if (my + rmHeight < pageHeight) {
          rm.style.top = my + 10 + "px";
        } else {
          rm.style.top = my - rmHeight - 10 + "px";
        }

        //3.显示右键菜单
        setTimeout(() => {
          this.rightMenuShow = true;
        }, 10);
        //阻止默认的右键菜单显示
        return false;
      })
    },
    // 选中
    pitchOn (e) {
      var event = window.event || e;
      let isTarget
      var target = event.srcElement ? event.srcElement : event.target;
      let pathList = Array.from(event.path);
      for (let i = 0; i < pathList.length; i++) {
        if (i > 3) {
          break
        }
        const element = pathList[i];
        if (element.getAttribute("type") === "target") {
          isTarget = true
          break
        }
      }
      if (
        /input|textarea/i.test(target.tagName) &&
        /firefox/i.test(navigator.userAgent)
      ) {
        //Firefox在文本框内选择文字
        var staIndex = target.selectionStart;
        var endIndex = target.selectionEnd;
        if (staIndex != endIndex) {
          var sText = target.value.substring(staIndex, endIndex);
          this.tanchu(sText, target, event, isTarget);
        }
      } else {
        //获取选中文字
        var sText =
          document.selection == undefined
            ? document.getSelection().toString()
            : document.selection.createRange().text;
        if (sText != "") {
          //将参数传入回调函数fn
          this.tanchu(sText, target, event, isTarget);
        }
      }
    },
    // 选中文字
    tanchu (txt, tar, event, isTarget) {
      if (isTarget) {
        this.targetInput = txt;
      } else {
        this.inputTxt = txt;
      }
      this.seekTxt = txt;
      // this.oncontextmenu(event)
      if (this.isSeekBox === 1) {
        this.seekChange();
      }
      this.txtList.push(txt);
      if (this.txtList.length > 4) {
        this.txtList.shift();
      }
    },
    // 获取文档
    getWord (partIndex, type, isTop) {
      // type=1 滚动条向下 type=2 滚动条向上 一页展示10个页码 isTop 自动加载的
      var that = this;
      let path = "";
      let marker;
      let taskType = that.queryData.taskType;
      if (that.queryData.transStatus === 2) {
        // 区分进入口 项目&任务
        marker = 2;
      } else {
        marker = 1;
      }
      if (that.isScroll) { // isScroll自動加載後300毫秒不可以觸發滾動
        return
      }
      // let loadinginstace = "";
      // loadinginstace = this.$loading({ fullscreen: true });
      this.catReq1Service(
        `/api/v1/file/load_edit_pair_file`,
        {
          // uid: that.uid,
          fileId: that.queryData.fileId,
          partIndex: partIndex,
          marker,
          taskType,
          comparedHighlight: this.isRecord ? 1 : 0,
          showTerm: true,
        },
        "get"
      ).then(function (response) {
        if (!response.success) {
          return;
        }
        if (that.cutOff) {
          return;
        }
        let data = response.result.sentPairContent, ifOnlyPreview = response.result.ifOnlyPreview;
        if (marker === 2) {   // 项目下不可编辑则不能添加术语
          that.ifOnlyPreview = !ifOnlyPreview;
        } else {  // 任务下不可编辑则不能添加术语，可编辑：在翻译状态下可以添加，审校等不可
          that.ifOnlyPreview = ifOnlyPreview ? !ifOnlyPreview : (that.queryData.taskType < 2 ? !ifOnlyPreview : false);
        }
        let ifRepeatLock = response.result.ifRepeatLock;
        if (type === 1 && data) {
          that.endIndex = partIndex;
          that.targetList.push({
            data,
            startSectionIndex: response.result.startSectionIndex,
            endSectionIndex: response.result.endSectionIndex
          });
          if (that.sourceList.length > 20) {
            that.targetList.shift();
          }
        } else if (type === 2 && data) {
          that.targetList.unshift({
            data,
            startSectionIndex: response.result.startSectionIndex,
            endSectionIndex: response.result.endSectionIndex
          });
          if (that.sourceList.length > 20) {
            that.endIndex = that.endIndex--;
            that.targetList.pop();
          }
        }

        var translation = document.getElementById("translation");
        var ary = translation.getElementsByTagName("div");
        if (marker === 1 && data) {
          // 自动加载到自己的任务
          let uidStr;
          switch (taskType) {
            case 2:
              uidStr = `reviserid="${that.queryData.userId}"`
              break;
            case 3:
              uidStr = `secondreviserid="${that.queryData.userId}"`
              break;
            default:
              uidStr = `uid="${that.queryData.userId}"`
              break;
          }
          if (data.indexOf(uidStr) === -1 && isTop) {
            that.num++;
            that.getWord(that.num, 1, true);
            return
          } else if (isTop) {
            setTimeout(async () => {
              let dom = that.$refs.viewBox2.querySelector(`div[${uidStr}]`);
              await dom.scrollIntoView() // 自动加载的要跳转
              that.loadinginstace.close(); // loading清除
              that.isScroll = true;
              setTimeout(() => {
                that.isScroll = false;
              }, 2000);
            }, 500);
          }
        }
        let onsourceList = [];
        that.$nextTick(() => {
        });
        setTimeout(() => {
          var arr = Array.from(ary);
          //  console.log( document.getElementsByClassName("lef").firstElementChild,"redactBox.firstElementChild")
          arr.forEach(item => {
            item.style.color = that.editorOff;
            item.style.fontFamily = "微软雅黑";
            item.style.outline = "none";
            // if (
            //   item.getAttribute("uid") === that.queryData.userId + "" &&
            //   item.getAttribute("type") === "target" &&
            //   marker === 2
            // ) {
            //   item.style.borderBottom = "1px black dashed";
            // }
            if (
              item.getAttribute("uid") &&
              item.getAttribute("uid") !== that.queryData.userId + "" &&
              marker === 1
            ) {
              item.setAttribute("title", "其他译员任务");
            } else if (item.getAttribute("reviserid") &&
              item.getAttribute("reviserid") !== that.queryData.userId + "" &&
              marker === 1 &&
              taskType === 2) {
              item.setAttribute("title", "其他审校任务");
            } else if (item.getAttribute("secondreviserid") &&
              item.getAttribute("secondreviserid") !== that.queryData.userId + "" &&
              marker === 1 &&
              taskType === 3) {
              item.setAttribute("title", "其他复审任务");
            }

            if (item.getAttribute("uk") !== "1" && item.getAttribute("rf") > 0 && ifRepeatLock) {
              // 锁定重复句段
              item.setAttribute("contenteditable", "false");
              item.setAttribute("title", "文件内重复句段锁定");
            } else if (item.getAttribute("uk") !== "1" && item.getAttribute("rp") > 0 && ifRepeatLock) {
              item.setAttribute("contenteditable", "false");
              item.setAttribute("title", "项目内跨文件重复句段锁定");
            }
            if (item.getAttribute("type") === "target") {
              that.setPostilId(item)
              item.parentNode.style.border = "1px solid black"; // td边框设置为黑色
              if (item.getAttribute('contenteditable') === 'plaintext-only') {
                item.setAttribute('contenteditable', that.contentEditableValue)
              }
              if (item.getAttribute("contenteditable") === that.contentEditableValue) {
                let status = item.getAttribute("status")
                if ((status == 2 && taskType === 1) || (status == 4 && taskType === 2) || (status == 5 && taskType === 3)) {
                  // status值为 -1删除 0未翻译 1机器翻译 2已编辑 3已完成 4审校 5复审
                  item.style.background = that.editorDe;
                }
                item.onkeydown = function ($event) {
                  that.enterKey($event);
                };
                item.oninput = function ($event) {
                  that.changeText($event.target);
                };
                item.onfocus = function ($event) {
                  that.onFocus($event);
                };
                item.addEventListener("blur", function ($event) {
                  that.blurText($event.target);
                });
                item.style.color = that.editorNo;

              } else {
                item.style.color = that.editorOff;
                onsourceList.push(item.getAttribute("sid"))
              }
            } else if (item.getAttribute("type") === "source") {
              item.setAttribute("contenteditable", that.contentEditableValue);
              item.oninput = function ($event) {
                if ($event.target.innerText !== that.myInnerText) {
                  $event.target.innerText = that.myInnerText;
                }
              };
              item.onfocus = function ($event) {
                that.myInnerText = $event.target.innerText;
              };
            }
          });
          onsourceList.forEach(item => {
            let lefTag = that.$refs.viewBox2.querySelector(`div[sid='${item}']`);
            lefTag.setAttribute("contenteditable", "false");
          })
          that.loadinginstace.close(); // loading清除
        }, 200);
        that.$nextTick(() => {
          if (data === "") {
            var viewBox2 = that.$refs.viewBox2;
            // if (viewBox.clientHeight > viewBox2.clientHeight) {
            //   viewBox2.style.height = viewBox.clientHeight + "px";
            //   viewBox.style.height = viewBox.clientHeight + "px";
            // } else if (viewBox.clientHeight < viewBox2.clientHeight) {
            //   viewBox.style.height = viewBox2.clientHeight + "px";
            //   viewBox2.style.height = viewBox2.clientHeight + "px";
            // }
            that.cutOff = true;
          }
          // 避免加载一段未出现滚动条
          let num = 5;
          if (that.hasScrollbar(that.$refs.viewBox2)) {
            num = that.$refs.viewBox2.scrollTop;
          }
          // that.$refs.viewBox2.scrollTop = num;
          if (!that.hasScrollbar(that.$refs.viewBox2) && data) {
            that.num++;
            that.getWord(that.num, 1, true);
          }
        });
      });
    },
    // 添加术语
    async addTermSent (isReplace) {
      const { fileId, taskId } = this.queryData
      const params = {
        taskId,
        fileId,
        isReplace,
        isTermHighlight: true,
        sourceSent: this.inputTxt,
        targetSent: this.targetInput,
      };
      const { success, result } = await this.updateAddTemporaryTermList(params)
      if (!success) {
        return false
      }
      this.$message.closeAll()
      this.$message.success('添加成功')
      this.inputTxt = "";
      this.targetInput = "";
      this.$nextTick(() => {
        if (result.length > 0) {
          result.forEach(item => {
            let itemDom = this.$refs.viewBox2.querySelectorAll(`div[sid='${item.id}']`);
            itemDom[1] ? itemDom[1].innerText = item.targetSent : null;
          })
        }
      })

      // this.catReq1Service("/api/v1/termSent/addTermSent", params).then(function (
      //   response
      // ) {
      //   that.dialogVisible = false;
      //   if (!response.success) {
      //     return;
      //   }
      //   let data = response.result;
      //   that.$nextTick(() => {
      //     if (data.length > 0) {
      //       data.forEach(item => {
      //         let itemDom = that.$refs.viewBox2.querySelectorAll(`div[sid='${item.id}']`);
      //         itemDom[1] ? itemDom[1].innerText = item.targetSent : null;
      //       })
      //     }
      //   })
      //   that.$message({
      //     message: isReplace ? "已替换所有未确认句段中的术语" : "术语已经添加到项目术语库",
      //     type: "success"
      //   });
      //   that.inputTxt = "";
      //   that.targetInput = "";
      // });
    },
    scrollDs () {
      this.scroll = document.body.scrollTop;
      console.log(this.scroll);
    },
    //  单词补全
    AutoComple (e) {
      if (this.queryData.targetLang != "en") {
        return;
      }
      if (e.data === null || e.data === " ") {
        return;
      }
      let that = this;
      let sentId = Number(e.target.getAttribute("sId"));
      this.mendSentId = sentId;
      let rigTag = this.$refs.viewBox2.querySelector(`div[sid='${sentId}']`);
      let wordDom = rigTag.parentNode;
      let lefTag = rigTag.parentNode.children[0];
      this.AutoCompleMixin(wordDom, lefTag.innerText, 'span')
    },
    // 回车确认
    enterKey (e) {
      let that = this;
      e = e || window.event;
      var k = e.keyCode || e.which;
      let taskType = this.queryData.taskType;
      let sentId = Number(e.target.getAttribute("sId"));
      let oAt = this.$refs.viewBox2;
      let lefTag = oAt.querySelector(`div[sid='${sentId}']`);
      if (k === 13) {
        e.returnValue = false;
        let isCommitVersion = 1
        this.changeText(e.target, isCommitVersion);
        this.$nextTick(() => {
          if (taskType === 1) {
            e.target.setAttribute("status", "2"); // 成功把状态改为2_翻译
          } else if (taskType === 2) {
            e.target.setAttribute("status", "4"); // 成功把状态改为4_审校
          } else {
            e.target.setAttribute("status", "5"); // 成功把状态改为5_复审
          }
        });
        let dom = oAt.querySelectorAll(`div[contenteditable]`);
        dom = Array.from(dom).filter((item) => item.getAttribute("type") === "target");
        dom.forEach((item, index) => {
          if (item.getAttribute("sId") == sentId && dom[index + 1]) {
            dom[index + 1].focus()
          }
        })

      } else {
        // if (this.contrastStatus) {
        //   this.contrastTag.innerHTML = this.contrastTag.innerText
        // }
        // if (e.target.isContentEditable) {
        //   let range = window.getSelection().getRangeAt(0);
        //   if (this.startOffset != range.startOffset) {
        //     this.contrastDebounce(lefTag, e.target)
        //   }
        // }

      }
    },
    // 聚焦事件
    async onFocus (e) {
      this.writingSpeed()
      const top = this.$refs.viewBox2.scrollTop
      this.interpreteruid = e.target.getAttribute("uid");
      let acticeClass = e.target.getAttribute("sid");
      let lefTag = this.$refs.viewBox2.querySelector(`div[sid='${acticeClass}']`);
      this.lefTagText = lefTag.innerText;
      let pid = e.target.getAttribute("pid");
      pid ? this.isAddPostil = false : this.isAddPostil = true
      let pos = e.target.getBoundingClientRect();
      let postilDom = document.getElementById("postilBox");
      this.postilTarget = {
        txt: e.target.innerText,
        sid: acticeClass,
        tag: e.target
      };
      postilDom.style.top = pos.y + top - 100 + "px";
      // var range = window.getSelection().getRangeAt(0); 鼠标位置
    },
    blurText (target) {
      let sentId = target.getAttribute("sid");
      this.interpreteruid = "";
      let lefTag = this.$refs.viewBox2.querySelector(`div[sid='${sentId}']`);
      if (this.contrastStatus) {
        lefTag.innerText = this.lefTagText;
        this.contrastStatus = false;
      }
      // let that = this
      // this.$nextTick(() => {
      //   let taskType = this.queryData.taskType;
      //   let status = Number(event.getAttribute("status"));
      //   if ((status == 2 && taskType === 1) || (status == 4 && taskType === 2) || (status == 5 && taskType === 3)) {
      //     event.style.backgroundColor = that.editorDe;
      //   } else {
      //     event.style.backgroundColor = "";
      //   }
      // });
    },
    // 修改
    changeText (event, isCommitVersion = 0) {
      if (event === this.ev) {
        clearInterval(this.updateTime);
      }
      this.ev = event;
      var that = this;
      let reg = /^c([0-9]+)$/;
      let sentId = Number(event.getAttribute("sId"));
      let status = Number(event.getAttribute("status"));
      let timer;
      let taskType = this.queryData.taskType;
      that.isWordBox = false;
      let wordActive = event.getElementsByClassName("wordActive")[0];
      if (wordActive) {
        // 用于单词补全 删除候选词
        wordActive.remove();
      }
      if (event.innerText === "") {
        event.innerHTML = "&nbsp;";
      } else if (event.innerText === "/n") {
        event.innerHTML = "&nbsp;"
      }
      // 获取所有div
      this.updateTime = window.setTimeout(() => {
        var translation = document.getElementById("translation");
        var divNode = translation.getElementsByTagName("div");
        for (let i of divNode) {
          //便利所有div
          if (
            i.getAttribute("title") === ("文件内重复句段锁定" || "项目内跨文件重复句段锁定") &&
            i.getAttribute("sourceMd516") ===
            event.getAttribute("sourceMd516")
          ) {
            //找出相同的重复句段
            i.innerText = event.innerText; // 修改相同句段的内容
          }
        }

        that.saveHint = "正在自动保存...";
        that.state = false;
        let costTime = this.oldTime ? (new Date() - this.oldTime - 3000) / 1000 : undefined;
        if (costTime <= 1) {
          costTime = 1;
        } else {
          Math.round(costTime)
        }
        let params = {
          isCommitVersion,
          isNewVersion: 1,
          isSaveVersion: 1,
          sentId,
          fileId: that.queryData.fileId,
          content: event.innerText,
          companyCode: localStorage.myCompanyCode,
          taskType: taskType,
          status,
          taskId: this.queryData.taskId,
          costTime
        };

        this.catReq1Service("/api/v1/file/updateFileSent", params)
          .then(function (response) {
            if (!response.success) {
              return;
            }
            that.saveHint = "自动保存成功！";
            that.writingSpeed();
            setTimeout(() => {
              that.saveHint = "";
            }, 500);
            that.$nextTick(() => {
              if (taskType === 1) {
                event.setAttribute("status", "2"); // 成功把状态改为2
              } else if (taskType === 2) {
                event.setAttribute("status", "4"); // 成功把状态改为4_审校
              } else {
                event.setAttribute("status", "5"); // 成功把状态改为4_复审
              }
              // let status = Number(event.getAttribute("status"));
              // if (status > 1 && status!=3) {
              event.style.backgroundColor = that.editorDe;
              // } else {
              //   event.style.backgroundColor = "";
              // }
            });
            clearTimeout(that.progressTime)
            that.progressTime = window.setTimeout(() => {
              that.getprogress();
            }, 10000);
          }).catch(function (error) {
            that.saveHint = "自动保存失败！";
            setTimeout(() => {
              that.saveHint = "";
            }, 500);
          }).finally(() => {
            that.state = true
          });
      }, 3000);
    },
    // 鼠标滑出
    styleOut (e) {
      this.$nextTick(() => {
        let acticeClass = e.target.getAttribute("sid");
        if (!acticeClass) {
          return;
        }
        // let lefTag = this.$refs.viewBox.querySelector(
        //   `div[sid='${acticeClass}']`
        // );
        let rigTag = this.$refs.viewBox2.querySelector(
          `div[sid='${acticeClass}']`
        );
        lefTag.classList.remove("mystyle");
        rigTag.classList.remove("mystyle");
        lefTag.style.boxShadow = "";
        rigTag.style.boxShadow = "";
        lefTag.style.fontSize = "";
        rigTag.style.fontSize = "";
      });
    },
  }
};
</script>
<style lang="less">
#translation {
  .XlsxpostilBut {
    // background: url("../../assets/imgs/editor/ckbz_normal.png") no-repeat;
    // height: 18px;
    // width: 18px;
    // display: inline-block;
    position: absolute;
    width: 0;
    height: 0;
    border-width: 6px;
    border-style: solid;
    border-color: rgb(6, 243, 144, 0.4) rgb(6, 243, 144, 0.4) transparent
      transparent;
    right: 0px;
    top: 0px;
    cursor: pointer;
  }

  .XlsxpostilBut:active {
    // background: url("../../assets/imgs/editor/ckbz_press.png") no-repeat;
  }
}

.backColorB {
  #translation {
    .XlsxpostilBut {
      background: url("~@/assets/imgs/editor/yj_ckbz_normal.png") no-repeat;
    }
  }
}
</style>
<style lang="less" scoped>
.backColorB {
  background: rgba(33, 44, 50, 1) !important;

  #sourceText {
    background: rgba(48, 51, 60, 1) !important;
  }

  #translation {
    background: rgba(48, 51, 60, 1) !important;
    color: #c6c6c6 !important;
  }

  .progressBox {
    color: white !important;
  }

  /deep/ .el-progress-bar__outer {
    background-color: #4d515f !important;
  }

  /deep/ .el-progress-bar__inner {
    background: #507383 !important;
  }

  /*下拉框颜色*/

  /deep/ .el-popper {
    /deep/ .el-scrollbar {
      /deep/ .el-scrollbar__view {
        /deep/ .el-select-dropdown__item {
          background: #507383 !important;
        }

        background: #507383 !important;
      }
    }
  }

  .operationBox {
    background: rgba(48, 51, 60, 1) !important;
    color: #c6c6c6 !important;

    h3 {
      background: #507383 !important;
    }

    h4 {
      color: #c6c6c6;
    }

    h5 {
      color: #c6c6c6;
    }

    // .replaceBox {
    //   span {
    //     color: white !important;
    //   }
    //   input {
    //     background: #507383 !important;
    //     border: none !important;
    //     color: white !important;
    //   }
    //   input::-webkit-input-placeholder {
    //     color: white !important;
    //   }
    //   .seekBox {
    //     i {
    //       background: #507383 !important;
    //     }
    //   }
    //   .replaceBtn {
    //     button {
    //       background: #507383 !important;
    //       color: white !important;
    //       border: none !important;
    //     }
    //     button:hover {
    //       background: #405964 !important;
    //     }
    //     button:active {
    //       background: #2c4753 !important;
    //     }
    //   }
    // }
    .find {
      div {
        input {
          background: #507383 !important;
          border: none !important;
          color: white !important;
        }

        input::-webkit-input-placeholder {
          color: white !important;
        }
      }

      .findBox {
        border: 1px solid #507383 !important;

        li {
          color: white !important;
        }
      }
    }

    .addTerm {
      input {
        background: #507383 !important;
        border: none !important;
        color: white !important;
      }

      input::-webkit-input-placeholder {
        color: white !important;
      }
    }

    button {
      background: #507383 !important;
      color: white !important;
      border: none !important;
    }

    button:hover {
      background: #405964 !important;
    }

    button:active {
      background: #2c4753 !important;
    }
  }

  /deep/ .el-select {
    /deep/ .el-input__inner {
      background: #507383 !important;
      border: none !important;
      color: white !important;
    }
  }

  /deep/ .el-button {
    background: #507383 !important;
    border: none !important;
    color: white !important;
  }
}

.mystyle {
  box-shadow: 2px 5px 2px 0px rgba(102, 102, 102, 0.5) !important;
  font-size: 18px;
}

.main {
  height: 100%;
  background: #f1f5ff;

  header {
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 9px 0px rgba(235, 246, 241, 1);
    height: 50px;
    // width: 100%;
    .top_l {
      float: left;
      // width: 300px;
      display: flex;
      align-items: center;
      height: 100%;

      .saveHint {
        //  line-height: 20px;
        margin-left: 20px;
      }

      button {
        float: left;
        width: 48px;
        height: 30px;
        background: rgba(102, 102, 102, 1);
        box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
        border-radius: 2px;
        color: white;
        font-size: 18px;
        margin: 0 20px;
      }

      p {
        max-width: 600px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .top_r {
      float: right;
      line-height: 50px;
      display: flex;
      justify-content: center;
      align-items: center;

      /deep/ .el-input {
        width: 160px;
      }

      // position: relative;
      .el-select {
        margin-right: 20px;

        .el-input {
          width: 160px;
        }
      }

      img {
        border-radius: 50%;
      }

      input {
        // width: 160px;
        height: 36px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(186, 185, 185, 1);
        border-radius: 2px;
      }

      a {
        margin-right: 40px;

        img {
          width: 40px;
          height: 40px;
          vertical-align: middle;
        }

        span {
          margin-left: 20px;
          width: 47px;
          height: 11px;
          font-size: 14px;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
        }
      }

      .out {
        // position: absolute;
        // top: 50%;
        // left: 60%;
        // transform: translate(0, -50%);
        width: 18px;
        height: 20px;
        margin-right: 60px;
        background: url("~@/assets/imgs/editor/hover_sign_out.png");
      }

      .out:hover {
        background: url("~@/assets/imgs/editor/sign_outhover.png");
      }

      .out :active {
        background: url("~@/assets/imgs/editor/sign_out_press.png");
      }
    }
  }

  .el-select {
    float: left;
    margin-left: 30px;
  }

  /deep/ .el-input__inner {
    height: 32px;
    line-height: 32px;
  }
}

.box {
  width: calc(100% - 360px);
  margin-left: 20px;
  // min-height: ;
  // padding-right: 30px;
  // margin-left: 1%;
  float: left;
  // overflow-y: auto;
  height: 100%;
  position: relative;
  z-index: 5;

  .riBoxSw {
    position: absolute;
    top: 50%;
    right: 0px;
    z-index: 100;
    font-size: 24px;
    transform: translateY(-50%);
    cursor: pointer;
  }
}

.rigContantBox {
  float: right;
  width: 300px;
  height: 100%;
  margin-right: 20px;
  position: relative;

  .riBoxSw {
    position: absolute;
    top: 50%;
    height: 50px;
    width: 13px;
    left: -20px;
    z-index: 30;
    font-size: 24px;
    transform: translateY(-50%);
    cursor: pointer;
  }

  .icon-left {
    background: url("~@/assets/imgs/editor/zhankai_normal.png") no-repeat;
  }

  .icon-left:active {
    background: url("~@/assets/imgs/editor/zhankai_press.png") no-repeat;
  }

  .icon-right {
    background: url("~@/assets/imgs/editor/shouqi_normal.png") no-repeat;
  }

  .icon-right:active {
    background: url("~@/assets/imgs/editor/shouqi_press.png") no-repeat;
  }
}

.operationBox {
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #fff;
  padding: 5px 0;
  box-sizing: border-box;

  .termTit {
    margin-left: 20px;
    width: 80%;
  }

  .operation {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    // .replaceBox {
    //   width: 100%;
    //   display: flex;
    //   flex-wrap: wrap;
    //   justify-content: center;
    //   padding: 0 20px;
    //   div {
    //     width: 100%;
    //     margin-bottom: 10px;
    //     display: flex;
    //     flex-wrap: wrap;
    //     justify-content: center;
    //     span {
    //       width: 24%;
    //       height: 36px;
    //       line-height: 36px;
    //     }
    //     input {
    //       width: 76%;
    //       height: 34px;
    //       line-height: 36px;
    //       border: 1px solid rgba(187, 187, 187, 1);
    //       border-radius: 4px;
    //       box-sizing: border-box;
    //     }
    //     input:focus {
    //       outline: none;
    //       border: 1px solid #454545;
    //     }
    //   }
    //   .seekBox {
    //     position: relative;
    //     .seekIndex {
    //       position: absolute;
    //       right: 8px;
    //       top: 10px;
    //       background: white;
    //       font-size: 12px;
    //       // color: #C0C4CC;
    //     }
    //     input {
    //       padding-right: 10%;
    //       width: 76%;
    //       height: 34px;
    //       line-height: 36px;
    //       border: 1px solid rgba(187, 187, 187, 1);
    //       border-radius: 4px;
    //     }
    //     input:focus {
    //       outline: none;
    //       border: 1px solid #454545;
    //     }
    //   }
    //   .replaceBtn {
    //     width: 90%;
    //     display: flex;
    //     flex-wrap: nowrap;
    //     justify-content: space-between;
    //     button {
    //       padding: 5px;
    //       font-size: 12px;
    //       color: #666666;
    //       border-radius: 2px;
    //       background: rgba(255, 255, 255, 1);
    //       border: 1px solid rgba(187, 187, 187, 1);
    //     }
    //     button:hover {
    //       background: rgba(244, 244, 244, 1);
    //     }
    //     button:active {
    //       background: rgba(69, 69, 69, 1);
    //       font-family: Microsoft YaHei;
    //       font-weight: 400;
    //       color: rgba(255, 255, 255, 1);
    //       border-radius: 2px;
    //     }
    //   }
    // }
    .addTerm {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      justify-content: center;
      padding: 0 20px;

      .sourceInput {
        width: 280px;
        height: 34px;
        line-height: 36px;
        border: 1px solid rgba(187, 187, 187, 1);
        border-radius: 4px;
        padding: 0 10px;
        margin-bottom: 10px;
        width: 100%;
      }

      .sourceInput:focus {
        outline: none;
        border: 1px solid #454545;
      }

      .addBox {
        // display: flex;
        // align-items: center;
        // justify-content: space-around;
        width: 100%;

        .targetInput {
          width: 50%;
          height: 34px;
          line-height: 36px;
          border: 1px solid rgba(187, 187, 187, 1);
          border-radius: 4px;
          padding: 0 10px;
        }

        .targetInput:focus {
          outline: none;
          border: 1px solid #454545;
        }

        button {
          width: 33%;
          height: 34px;
          background: rgba(69, 69, 69, 1);
          border-radius: 4px;
          border: 0px;
          font-size: 14px;
          color: rgba(255, 255, 255, 1);
          float: right;
          padding: 0;
        }
      }
    }

    .find {
      width: 100%;
      margin-top: 20px;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      position: relative;
      padding: 0 20px;

      div {
        position: relative;
        width: 100%;
        margin: 0 auto;
        display: flex;
        justify-content: center;

        input {
          //  float: right;
          width: 100%;
          height: 34px;
          line-height: 36px;
          border: 1px solid rgba(187, 187, 187, 1);
          border-radius: 4px;
          padding: 0 10px;
          padding-right: 26px;
        }

        .search {
          position: absolute;
          right: 3%;
          top: 10px;
          cursor: pointer;
        }
      }

      .findBox {
        min-height: 50px;
        max-height: 180px;
        width: 100%;
        border: 1px solid rgba(187, 187, 187, 1);
        border-radius: 4px;
        text-align: left;
        padding: 10px;
        overflow: auto;

        li {
          padding: 3px 0;

          span {
            font-weight: 700;
          }
        }
      }

      h5 {
        margin: 10px 0;
        margin-top: 10px;
        text-align: left;
        width: 100%;
      }
    }
  }

  .hint::-webkit-scrollbar {
    width: 0 !important;
  }

  .hint {
    max-height: 160px;
    overflow: auto;
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
    // border: #cdeb9c 1px solid;
    li {
      // float: left;
      margin: 0 20px;

      p {
        word-wrap: break-word;
        word-break: normal;
      }
    }
  }

  h4 {
    text-align: left;
    margin-top: 20px;
    margin-left: 20px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: rgba(34, 34, 34, 1);

    h3 {
      // border-left: 5px solid #166DC3;
      width: 4px;
      height: 18px;
      background: rgba(69, 69, 69, 1);
      float: left;
      margin-right: 15px;
      position: relative;
      top: 4px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgba(34, 34, 34, 1);
    }
  }

  h5 {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: rgba(34, 34, 34, 1);
    margin: 20px 0;
    width: 100%;
    text-align: left;
  }
}

.lefBag {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  float: left;
  background: #fff;
  width: 47%;
}

.lefBag::-webkit-scrollbar {
  display: none;
}

.lef {
  // float: left;
  position: relative;
  //   background: #1e82d2;
  min-height: 760px;
  // height:100%;
  height: 760px;
  // overflow-x: hidden;
  // overflow-y: scroll;
  // width: 45%;
  word-break: normal;
  background: #fff;
  padding: 20px;
  z-index: 50;
}

.rig {
  //   background: darkgray;
  min-height: 760px;
  position: relative;
  height: 760px;
  // height: 100%;
  overflow: auto;
  width: 47%;
  float: right;
  background: #fff;
  padding: 20px;
  z-index: 50;
  // background: #cdeb9c;
}

.cen {
  //   background: darkgray;
  position: relative;
  height: 100%;
  // height: 100%;
  overflow: auto;
  width: 100%;
  margin: 0 auto;
  background: #fff;
  padding: 40px;
  z-index: 50;
  box-sizing: border-box;
  // background: #cdeb9c;
}

span:focus {
  outline: -webkit-focus-ring-color auto 0px !important;
}

#WordBox {
  position: absolute;
  padding: 5px;
  z-index: 1000;
  border-radius: 5px;
  background: #666666;
  color: #fff;
}

#shortcutKey {
  li {
    // color: aqua;
    // display: flex;
    // flex-wrap: wrap;
    // justify-content: space-around;
    p:nth-child(1) {
      width: 200px;
      float: left;
    }

    p {
      margin-bottom: 10px;
    }
  }

  .tit {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
  }
}

#bagBox {
  background: #f1f5ff;
  height: calc(100% - 115px);
}

.el-scrollbar {
  .el-scrollbar__view {
    .el-select-dropdown__item {
      padding: 0px 0px !important;
      text-align: center;

      a {
        display: block;
      }
    }
  }
}
</style>
